import { Grid } from '@mui/material';
import FieldText from '../../../components/general/fields/fieldText';
import LoadingButtonGeneral from '../../../components/general/buttons/loadingButtonGeneral';
import { useUserFilters } from './hook';
import { UserFiltersProps } from './props';
import { Checkbox } from '../../../components/general/fields/checkbox';
import dayjs from 'dayjs';
import DatePickerField from '../../../components/general/fields/datePickerField';

export const UserFilters = ({ onFilter, loading }: UserFiltersProps) => {
    const { formik } = useUserFilters(onFilter);

    return (
        <Grid container spacing={{ xs: 1.5, md: 1.5 }}>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Nombre de usuario"
                    name="username"
                    size="small"
                    touched={formik.touched.username}
                    errors={formik.errors.username}
                    value={formik.values.username}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Documento"
                    name="document"
                    size="small"
                    touched={formik.touched.document}
                    errors={formik.errors.document}
                    value={formik.values.document}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Nombre"
                    name="name"
                    size="small"
                    touched={formik.touched.name}
                    errors={formik.errors.name}
                    value={formik.values.name}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Apellido"
                    name="surname"
                    size="small"
                    touched={formik.touched.surname}
                    errors={formik.errors.surname}
                    value={formik.values.surname}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Checkbox
                    label="Activo"
                    checked={Boolean(formik.values.active)}
                    onChange={() => {
                        formik.setFieldValue('active', !formik.values.active);
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <DatePickerField
                    label="Fecha de creación"
                    name="created_at"
                    size="small"
                    maxDate={dayjs()}
                    touched={formik.touched.created_at}
                    errors={formik.errors.created_at?.toString()}
                    value={formik.values.created_at}
                    onChange={(value) =>
                        formik.setFieldValue('created_at', value, true)
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Buscar"
                    sx={{ mr: 1 }}
                    onClick={formik.submitForm}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Limpiar"
                    variant="outlined"
                    onClick={formik.resetForm}
                />
            </Grid>
        </Grid>
    );
};
